module.exports = __webpack_public_path__ + "media/images/zalo_icon_white-ea75e0b0f44356c5b8111252df8a174e.png";